
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hard/gorilla/infielder",
      function () {
        return require("private-next-pages/hard/gorilla/infielder/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hard/gorilla/infielder"])
      });
    }
  